import { render, staticRenderFns } from "./GaSensitivityBadge.vue?vue&type=template&id=01ab6a2e&"
import script from "./GaSensitivityBadge.vue?vue&type=script&lang=ts&"
export * from "./GaSensitivityBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports